<template>
  <a-card :bordered="false">
    <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        新增
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #major="{ text }">
        <dict-render :dict-obj="dictObjs['education_major']" :text="text"></dict-render>
      </template>
      <template #educationBackground="{ text }">
        <dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
      </template>
      <template #action="{ record }">
        <div class="table-row-operations">
          <a @click="onEdit(record)">编辑</a>
        </div>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import UserModal from './components/UserModal';
import { tableListMixin, dictMixin } from "@/mixins";
import { eduExpriseInfo } from "@/api/educationService";
import { dateFormat } from "@/config/variableConfig";
import DictRender from "@/components/other/DictRender";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "学校名称", dataIndex: "schoolName", key: "schoolName" },
  { title: '入学时间', dataIndex: "entryTime", key: "entryTime" },
  { title: '毕业时间', dataIndex: "graduationTime", key: "graduationTime" },
  { title: '所学专业', dataIndex: "major", key: "major", slots: { customRender: "major" } },
  { title: '所获学历', dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, dictMixin],
  components: {
    UserModal, DictRender
  },
  data() {
    return {
      dictNames: 'education_major,education_background',
      dateFormat,
      columns,
      queryParam: {},
      listUrl: eduExpriseInfo.pageList,
      listKeyField: "id",
      deleteUrl: eduExpriseInfo.remove,
      editUrl: eduExpriseInfo.saveupdate,
    }
  },
  methods: {
    onAdd() {
      this.onShowModal('userModal');
    },
    onEdit(record) {
      this.getAction({
        url: eduExpriseInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
  }
}
</script>

<style scoped></style>
